// React Imports
import { useParams } from "react-router-dom";
// Custom
import {VegzelmaEntry} from "./VegzelmaEntry";
import YuflymaEntry from "./YuflymaEntry";
import {ZymfentraEntry} from "./ZymfentraEntry";
import {AdalimumabAATYEntry} from "./AdalimumabAaty";
import {SteqeymaEntry} from "./SteqeymaEntry";
import {OsenveltEntry} from "./OsenveltEntry";
import {StobocloEntry} from "./StobocloEntry";
import {AvtozmaEntry} from "./AvtozmaEntry";
const Entry = () => {
  const { category } = useParams();

  return (
    <span> 
      {category === "vegzelma" ? (
        <VegzelmaEntry />
      ) : category === "yuflyma" ? (
        <YuflymaEntry />
      ) : category === "zymfentra" ? (
        <ZymfentraEntry />
      ) : category === "adalimumab" ? (
        <AdalimumabAATYEntry />
      ) : category === "steqeyma" ? (
        <SteqeymaEntry />
      ) : category === "osenvelt" ? (
        <OsenveltEntry />
      ) : category === "stoboclo" ? (
        <StobocloEntry />
      ) : category === "avtozma" ? (
        <AvtozmaEntry />
      ):null}
    </span>
  );
};

export default Entry;
